import witness from "./witness";
import witnessHold from "./witness-hold";
import witnessSolo from "./witness-solo";

export default {
    witness,
    "witness-hold": witnessHold,
    "witness-solo": witnessSolo
}